import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, CalendarDays } from 'lucide-react';
import { HamburgerMenu } from '../components/HamburgerMenu';
import { NewsletterSignup } from '../components/NewsletterSignup';
import { SEO } from '../components/SEO';
import { getPostsNewestFirst } from '../journal/posts';
export function Journal() {
  const posts = getPostsNewestFirst();
  return <div className="min-h-screen bg-[#0a0a0a] text-white selection:bg-[#D97E3A] selection:text-white" data-id="element-412" data-mp="1o13rlcgvc2q8">
      <SEO title="Journal - Coffee, Community & Livermore | Grounded" description="Stories on coffee, community, and life in Livermore from the team at Grounded." canonical="https://www.groundedlivermore.com/journal" data-id="element-413" data-mp="1t0gf7zfkddtv" />
      <HamburgerMenu data-id="element-414" data-mp="21xqtltnohj30" />

      <main data-id="element-415" data-mp="39dx3ucj9ldc2">
        {/* Header */}
        <header className="pt-32 pb-16 px-6 md:px-12 lg:px-24 max-w-5xl mx-auto" data-id="element-416" data-mp="39cvjfhgczeho">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} data-id="element-417" data-mp="3de7bruqmadtk">
            <div className="flex items-center gap-3 mb-6" data-id="element-418" data-mp="2tcp36mehcm5w">
              <div className="h-px w-12 bg-[#D97E3A]" data-id="element-419" data-mp="2tb45inwvcn3t" />
              <span className="text-[#D97E3A] font-inter font-medium tracking-widest text-xs uppercase" data-id="element-420" data-mp="2od2p6aqtv1w1">
                From the Shop
              </span>
            </div>

            <h1 className="font-bebas text-6xl md:text-8xl leading-[0.9] mb-8" data-id="element-421" data-mp="2fd5wly1bhivp">
              JOURNAL
            </h1>

            <p className="font-inter text-lg text-white/70 leading-relaxed max-w-2xl border-l-2 border-[#D97E3A] pl-6" data-id="element-422" data-mp="2amfseo4mnm2l">
              Stories on coffee, community, and life in Livermore from the team
              at Grounded.
            </p>
          </motion.div>
        </header>

        {/* Post list */}
        <section aria-label="Journal posts" className="px-6 md:px-12 lg:px-24 max-w-5xl mx-auto pb-24" data-id="element-423" data-mp="1wlwjzfw92dzw">
          {posts.length === 0 ? <p className="font-inter text-white/50 border-t border-white/10 pt-10" data-id="element-424" data-mp="1i0hens5qcouv">
              No posts yet — check back soon.
            </p> : <ul className="space-y-6" data-id="element-425" data-mp="1lzq44ktqm0km">
              {posts.map((post, i) => <motion.li key={post.slug} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.08
          }} data-id="element-426" data-mp="183mfr85jomg2" data-mpi={i}>
                  <article className="border border-white/10 bg-[#111] p-8 md:p-10 transition-colors hover:border-[#D97E3A]/40" data-id="element-427" data-mp="25oihqlk53d2w">
                    <div className="flex items-center gap-2 text-[#D97E3A] font-inter text-xs font-medium uppercase tracking-widest mb-4" data-id="element-428" data-mp="1qyt8e31w82rj">
                      <CalendarDays size={14} aria-hidden="true" data-id="element-429" data-mp="2jpbbv56j465h" />
                      <time dateTime={post.datePublished} data-id="element-430" data-mp="2jnrxxl8ci76v">{post.date}</time>
                    </div>

                    <h2 className="font-bebas text-3xl md:text-5xl leading-[0.95] mb-4" data-id="element-431" data-mp="d1cdbf2j4tis">
                      <Link to={`/journal/${post.slug}`} className="hover:text-[#D97E3A] transition-colors" data-id="element-432" data-mp="cyzl893252s0">
                        {post.title}
                      </Link>
                    </h2>

                    <p className="font-inter text-base text-white/60 leading-relaxed mb-6 max-w-2xl" data-id="element-433" data-mp="hskly8w1cauw">
                      {post.excerpt}
                    </p>

                    <Link to={`/journal/${post.slug}`} className="inline-flex items-center gap-2 font-bebas text-lg tracking-wide text-[#D97E3A] hover:gap-3 transition-all group" data-id="element-434" data-mp="3l9b1bedic099">
                      READ MORE
                      <ArrowRight size={18} aria-hidden="true" className="group-hover:translate-x-1 transition-transform" data-id="element-435" data-mp="1eibkcj7g6i5z" />
                    </Link>
                  </article>
                </motion.li>)}
            </ul>}
        </section>

        <NewsletterSignup data-id="element-436" data-mp="29t0460ellknp" />

        <footer className="border-t border-white/10 py-12 text-center" data-id="element-437" data-mp="29ub7jz44sqea">
          <p className="font-bebas text-2xl text-white/50" data-id="element-438" data-mp="2eq9s1bmc9o9f">
            © {new Date().getFullYear()} GROUNDED LIVERMORE
          </p>
        </footer>
      </main>
    </div>;
}